import { useCallback, useEffect, useRef } from 'react';
import videojs from 'video.js';
import Api from '../../api';
import { customObjValues } from '../../formatters';
import { FuneralServiceMediaSource } from '../../types';
import ViewerCount from './ViewerCount';

const VideoViewer = ({
  source,
  isLive,
  viewerCount,
  viewerStats,
  sourceHash,
}: {
  source?: FuneralServiceMediaSource;
  isLive: boolean;
  viewerCount: number;
  viewerStats: boolean;
  sourceHash: any[] | null;
}) => {
  const player = useRef<videojs.Player | null>(null);

  const videoRef = useRef<any>(null);

  const onPlay = useCallback(() => {
    if (!sourceHash) return null;

    if (sourceHash[1] === 'stream') {
      Api.streamViewerCount(sourceHash[0]);
    }

    if (sourceHash[1] === 'video') {
      Api.videoViewerCount(sourceHash[0]);
    }
  }, [sourceHash, source]);

  useEffect(() => {
    if (source) {
      const options = {
        autoplay: isLive,
        controls: true,
        responsive: true,
        fluid: true,
        sources: [
          {
            src: customObjValues(source)[0][0]?.url ?? source.url,
            type: customObjValues(source)[0][0]?.mime_type ?? source.mime_type,
          },
        ],
      };

      if (!player.current) {
        const videoElement = videoRef.current;
        if (!videoElement) return;

        player.current = videojs(videoElement, options, () => {
          videoElement?.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' });
          player.current?.on('play', () => {
            if (player.current?.currentTime() === 0) {
              onPlay();
            }
          });
        });
      } else {
        player.current.autoplay(options.autoplay);
        player.current.src(options.sources);
      }
    }

    return () => {
      if (player.current) {
        player.current.dispose();
        player.current = null;
      }
    };
  }, [videoRef, source]);

  return (
    <div className="main-video">
      <div key={sourceHash} data-vjs-player>
        {isLive && viewerStats && <ViewerCount viewerCount={viewerCount} />}
        <video ref={videoRef} className="video-js vjs-default-skin vjs-16-9 vjs-big-play-centered" />
      </div>
    </div>
  );
};

export default VideoViewer;
